/**
 * @fileoverview GET handler for the "/companies/:company_id/app_groups" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAppGroups } from "./constants";
import type { CompaniesCompanyIdAppGroupsResult } from "./types";
import { isCompaniesCompanyIdAppGroupsResult } from "./validators";

export const getCompaniesCompanyIdAppGroups = reactQueryFetcherAdapter(
  companiesCompanyIdAppGroups,
  (signal: AbortSignal, companyId: string): Promise<CompaniesCompanyIdAppGroupsResult> => {
    return fetch(`/companies/${companyId}/app_groups`, "GET", {}, { signal });
  },
  isCompaniesCompanyIdAppGroupsResult
);
